import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { PwaUpdateBanner } from "@cliqsuite/ui";

/** POS updates remain user-controlled so an active sale is never reloaded. */
export function UpdateBanner() {
  const [registration, setRegistration] = useState<ServiceWorkerRegistration | null>(null);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({ onRegisteredSW: (_url, value) => setRegistration(value ?? null) });

  return (
    <PwaUpdateBanner
      needRefresh={needRefresh}
      setNeedRefresh={setNeedRefresh}
      updateServiceWorker={updateServiceWorker}
      registration={registration}
      message="A new version is ready. Update after this sale."
      allowDismiss={false}
    />
  );
}
